/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum tagTypeEnum {
    TAGS = 'tags',
    CUSTOM = 'custom',
    ALL = 'all',
}